import { render, staticRenderFns } from "./AdvancedResourceSelect.vue?vue&type=template&id=efff7dd2&scoped=true"
import script from "./AdvancedResourceSelect.vue?vue&type=script&lang=js"
export * from "./AdvancedResourceSelect.vue?vue&type=script&lang=js"
import style0 from "./AdvancedResourceSelect.vue?vue&type=style&index=0&id=efff7dd2&prod&scoped=true&lang=scss"
import style1 from "./AdvancedResourceSelect.vue?vue&type=style&index=1&id=efff7dd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efff7dd2",
  null
  
)

export default component.exports